var regexAllHtmlTags = /<[/]?[a-zA-Z]+[^>]*[/]?>/g;
var wikiTextNewLine = /\\\\/g;
var regexNewLine = /\n/g;
var enclosings = [
    { wiki: '//', opening: '<i>', closing: '</i>' },
    { wiki: '**', opening: '<b>', closing: '</b>' },
    { wiki: '__', opening: '<u>', closing: '</u>' },
];
var breakTag = '<br />';
var sanitizeAsWikiText = function (blurbWithHtml) {
    var blurb = blurbWithHtml.replace(regexAllHtmlTags, '').replace(regexNewLine, '');
    var result = [];
    var enclosingStack = [];
    var processedLetters = 0;
    var _loop_1 = function () {
        var nextIndex = getNextIndex(blurb, processedLetters);
        // no enclosing ahead anymore -> stop and add all missing characters
        if (nextIndex === -1) {
            result.push(blurb.substring(processedLetters));
            return "break";
        }
        // add all characters in between
        if (nextIndex > processedLetters) {
            result.push(blurb.substring(processedLetters, nextIndex));
        }
        var enclosing /* Enclosing */ = blurb.substring(nextIndex, nextIndex + 2);
        if (enclosingStack[enclosingStack.length - 1] !== enclosing) {
            // open tag
            enclosingStack.push(enclosing);
            enclosings.forEach(function (e) {
                if (e.wiki === enclosing)
                    result.push(e.opening);
            });
        }
        else {
            // close tag;
            enclosingStack.pop();
            enclosings.forEach(function (e) {
                if (e.wiki === enclosing)
                    result.push(e.closing);
            });
        }
        processedLetters = nextIndex + 2;
    };
    while (processedLetters < blurb.length) {
        var state_1 = _loop_1();
        if (state_1 === "break")
            break;
    }
    enclosingStack.reverse().forEach(function (s) {
        enclosings.forEach(function (e) {
            if (e.wiki === s)
                result.push(e.closing);
        });
    });
    return result.join('').replace(wikiTextNewLine, breakTag);
};
var matchesWikiText = function (blurb) {
    return wikiTextNewLine.test(blurb) ||
        hasTwoEnclosingStrings(blurb, '/') ||
        hasTwoEnclosingStrings(blurb, '\\*') ||
        hasTwoEnclosingStrings(blurb, '_');
};
var getNextIndex = function (blurb, start) {
    return enclosings
        .map(function (e) { return blurb.indexOf(e.wiki, start); })
        .filter(function (n) { return n > -1; })
        .reduce(function (current, n) { return (current === -1 || n < current ? n : current); }, -1);
};
var hasTwoEnclosingStrings = function (test, enclosing) {
    return RegExp(enclosing + "{2}.*" + enclosing + "{2}").test(test);
};
var sanitizeAsHtml = function (blurb) {
    return blurb
        .replace(/<br[^>]*[/]?>/g, '\n')
        .replace(regexAllHtmlTags, '')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(regexNewLine, breakTag);
};
var sanitizeBlurb = function (blurb) {
    return matchesWikiText(blurb) ? sanitizeAsWikiText(blurb) : sanitizeAsHtml(blurb);
};
var BlurbUtil = { matchesWikiText: matchesWikiText, sanitize: sanitizeBlurb };

export { BlurbUtil };
